<!-- ------- --------- ------- -->
<!-- ------- Button Toggle ------- -->
<!-- ------- --------- ------- -->

<h2>Toggle Button</h2>

<div class="flex-container">
  <div class="flex-row">
    <div class="col-6 col-sm-12">
      <app-ui-button-toggle>
        <label>
          <span [innerHTML]="randomDescriptionShort"></span>
          <app-ui-tooltip [content]="content" size="small"></app-ui-tooltip>
        </label>
      </app-ui-button-toggle>
    </div>
    <div class="col-6 col-sm-12">
      <app-ui-button-toggle [checked]="true">
        <label>
          <span [innerHTML]="randomDescription"></span>
          <app-ui-tooltip [content]="content" size="small"></app-ui-tooltip>
        </label>
      </app-ui-button-toggle>
    </div>
  </div>
  <div class="flex-row flex-justify-center">
    <div class="col-6 col-sm-12">
      <app-ui-button-toggle>
        <label>
          <span [innerHTML]="randomDescriptionLong"></span>
          <app-ui-tooltip [content]="content" size="small"></app-ui-tooltip>
        </label>
      </app-ui-button-toggle>
    </div>
    <div class="col-6 col-sm-12">
      <app-ui-button-toggle>
        <label>
          <span [innerHTML]="randomDescription"></span>
        </label>
      </app-ui-button-toggle>
    </div>
  </div>
</div>

<!-- ------- ------- ------- -->
<!-- ------- TOOLTIP ------- -->
<!-- ------- ------- ------- -->
<div class="full split">
  <app-ui-tooltip [content]="content"></app-ui-tooltip>
  <app-ui-tooltip [content]="content"></app-ui-tooltip>
  <app-ui-tooltip [content]="content"></app-ui-tooltip>
</div>
<h2>Tooltip</h2>
<div class="input-play">
  <p>Try to set your own input text or text with a tag link:</p>
  <input type="text" [(ngModel)]="content" />
</div>
<div class="full split">
  <app-ui-tooltip [content]="content"></app-ui-tooltip>
  <span> Without title <app-ui-tooltip [content]="content"></app-ui-tooltip> </span>
  <span> With title <app-ui-tooltip [content]="content" [title]="title"></app-ui-tooltip> </span>
  <app-ui-tooltip [content]="content"></app-ui-tooltip>
</div>
<div class="content">
  <p>
    Text here and then tooltip Text here and then tooltip Text here and then tooltip Text here and then tooltip Text here and then tooltip
    Text here and then tooltip Text here and then tooltip Text here and then tooltip Text here and then tooltip Text here and then tooltip
    Text here and then tooltip
    <app-ui-tooltip [content]="content"></app-ui-tooltip>
  </p>
</div>
<div class="content">
  <p>
    Text here and then tooltip
    <app-ui-tooltip [content]="content"></app-ui-tooltip>
  </p>
</div>
<div class="content split">
  <span>Text here and then tooltip</span>
  <app-ui-tooltip [content]="content"></app-ui-tooltip>
</div>

<!-- ------- --------- ------- -->
<!-- ------- ERROR BOX ------- -->
<!-- ------- --------- ------- -->

<h2>Error box</h2>

<!-- Error box with title, without checkbox -->
<div class="content clear">
  <app-ui-feedback [feedback]="'error'" [title]="'Clear error label'" [description]="randomDescription"></app-ui-feedback>
</div>

<!-- Error box with title, with checkbox -->
<div class="content clear">
  <app-ui-feedback
    [feedback]="'error'"
    [title]="'Clear error label'"
    [description]="randomDescription"
    [actionDescription]="randomActionDescription"
    [checkboxStatus]="checkboxStatusOne"
    (changeCheckbox)="checkboxStatusOne = $event"
    [id]="'checkbox1'"
  >
  </app-ui-feedback>
</div>

<!-- Error box without title, without checkbox -->
<div class="content clear">
  <app-ui-feedback [feedback]="'error'" [description]="randomDescription"></app-ui-feedback>
</div>

<!-- Error box without title, with checkbox -->
<div class="content clear">
  <app-ui-feedback
    [feedback]="'error'"
    [description]="randomDescription"
    [actionDescription]="randomActionDescription"
    [checkboxStatus]="checkboxStatusTwo"
    (changeCheckbox)="checkboxStatusTwo = $event"
    [id]="'checkbox2'"
  >
  </app-ui-feedback>
</div>

<!-- Error box without title, with checkbox, with long descriptions -->
<div class="content clear">
  <app-ui-feedback
    [feedback]="'error'"
    [description]="randomDescriptionLong"
    [actionDescription]="randomActionDescriptionLong"
    [checkboxStatus]="checkboxStatusThree"
    (changeCheckbox)="checkboxStatusThree = $event"
    [id]="'checkbox3'"
  >
  </app-ui-feedback>
</div>

<!-- ------- --------- ------- -->
<!-- ------- SINGLE CHECKBOX ------- -->
<!-- ------- --------- ------- -->

<h2>Single checkbox</h2>

<!-- Single checkbox  -->
<div class="content clear">
  <app-ui-checkbox [(ngModel)]="singleCheckboxStatusOne">{{ randomLabel }}</app-ui-checkbox>
</div>

<!-- Single checkbox long label -->
<div class="content clear">
  <app-ui-checkbox [(ngModel)]="singleCheckboxStatusOneLong">{{ randomLabelLong }}</app-ui-checkbox>
</div>

<!-- Single checkbox with tooltip -->

<div class="content clear">
  <div class="split">
    <app-ui-checkbox [(ngModel)]="singleCheckboxStatusTwo">
      {{ randomLabel }}
    </app-ui-checkbox>
    <app-ui-tooltip [content]="content" size="small"></app-ui-tooltip>
  </div>
</div>

<!-- Single checkbox long label with tooltip -->

<div class="content clear">
  <div class="split">
    <app-ui-checkbox [(ngModel)]="singleCheckboxStatusTwoLong">
      {{ randomLabelLong }}
    </app-ui-checkbox>
    <app-ui-tooltip [content]="content" size="small"></app-ui-tooltip>
  </div>
</div>

<!-- Single checkbox disabled -->

<div class="content clear">
  <app-ui-checkbox [hasError]="errorStateCheckbox" [(ngModel)]="singleCheckboxStatusThree">{{ randomLabel }}</app-ui-checkbox>
</div>

<!-- Single checkbox disabled with tooltip -->

<div class="content clear">
  <div class="split">
    <app-ui-checkbox [(ngModel)]="singleCheckboxStatusFour" [hasError]="errorStateCheckbox">
      {{ randomLabelLong }}
    </app-ui-checkbox>
    <app-ui-tooltip [content]="content" size="small"></app-ui-tooltip>
  </div>
</div>

<h2>Checkbox Group</h2>

<!-- Checkbox group-->
<div class="content clear">
  <div class="split">
    <form [formGroup]="checkboxGroupForm">
      <app-ui-checkbox-group
        [label]="'Reactive form example'"
        [hasError]="checkboxGroupForm.get('checkboxGroup').hasError('required')"
        [errorMessage]="'required' | translate"
        formControlName="checkboxGroup"
      >
        <app-ui-checkbox-group-item *ngFor="let checkbox of checkboxItems" [value]="checkbox.value">{{
          checkbox.label
        }}</app-ui-checkbox-group-item>
      </app-ui-checkbox-group>
      <pre>
        {{ checkboxGroupForm.value | json }}
      </pre>
    </form>
  </div>
</div>

<div class="content clear">
  <div class="split">
    <form [formGroup]="checkboxGroupForm2">
      <app-ui-checkbox-group
        [label]="'Reactive form with the tooltip example, very very very long label and ordered selection result'"
        [tooltipText]="'This is a cool tooltip text with the long long long long'"
        [hasError]="checkboxGroupForm2.get('checkboxGroup').hasError('required')"
        [errorMessage]="'required' | translate"
        [selectionOrder]="true"
        formControlName="checkboxGroup"
      >
        <app-ui-checkbox-group-item *ngFor="let checkbox of checkboxItems" [value]="checkbox.value"
          ><span [innerHTML]="checkbox.label"></span
        ></app-ui-checkbox-group-item>
      </app-ui-checkbox-group>
      <pre>
        {{ checkboxGroupForm2.value | json }}
      </pre>
    </form>
  </div>
</div>

<div class="content clear">
  <div class="split">
    <div>
      <app-ui-checkbox-group
        [label]="'Template driven form example [(ngModel)]'"
        [tooltipText]="'This is tooltip'"
        [(ngModel)]="checkboxGroup"
      >
        <app-ui-checkbox-group-item *ngFor="let checkbox of checkboxItems" [value]="checkbox.value">{{
          checkbox.label
        }}</app-ui-checkbox-group-item>
      </app-ui-checkbox-group>
      <pre>
        {{ checkboxGroup | json }}
      </pre>
    </div>
  </div>
</div>

<div class="content clear">
  <div class="split">
    <div>
      <app-ui-checkbox-group
        [label]="'Template driven form example with the numbers formControl directive'"
        [formControl]="checkboxGroup2"
        [selectionOrder]="true"
      >
        <app-ui-checkbox-group-item [value]="1">Number 1</app-ui-checkbox-group-item>
        <app-ui-checkbox-group-item [value]="2">Number 2</app-ui-checkbox-group-item>
        <app-ui-checkbox-group-item [value]="3">Number 3</app-ui-checkbox-group-item>
        <app-ui-checkbox-group-item [value]="4">Number 4</app-ui-checkbox-group-item>
      </app-ui-checkbox-group>
      <pre>
        {{ checkboxGroup2.value | json }}
      </pre>
    </div>
  </div>
</div>

<!-- Radio group -->

<h2>Radio Group</h2>

<div class="content clear">
  <div class="split">
    <app-ui-radio-group
      [label]="'account.personal-information.labels.gender.label' | translate"
      [tooltipText]="'new_strategy.notifications.risk_recheck.tooltip.p1' | translate"
      [horizonalPosition]="true"
    >
      <app-ui-radio-button [value]="1" [(ngModel)]="radioButtonExample">Option1</app-ui-radio-button>
      <app-ui-radio-button [value]="2" [(ngModel)]="radioButtonExample">Option2</app-ui-radio-button>
      <app-ui-radio-button [value]="3" [(ngModel)]="radioButtonExample">Option3</app-ui-radio-button>
    </app-ui-radio-group>
  </div>
</div>

<form [formGroup]="radioGroupForm">
  <div class="content clear">
    <div class="split">
      <app-ui-radio-group [label]="'account.personal-information.labels.gender.label' | translate" [hasError]="radioGroupForm.invalid">
        <app-ui-radio-button
          [value]="1"
          [tooltipText]="'account.personal-information.labels.gender.label' | translate"
          formControlName="radio"
          >Option1</app-ui-radio-button
        >
        <app-ui-radio-button [value]="2" formControlName="radio">Option2</app-ui-radio-button>
        <app-ui-radio-button [value]="3" formControlName="radio">Option3</app-ui-radio-button>
        <app-ui-radio-button [value]="4" formControlName="radio">Option4</app-ui-radio-button>
      </app-ui-radio-group>
    </div>
  </div>
</form>

<!-- FOLLOW WITH NEXT UI SHOWCASE ELEMENTS -->
